import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout file for /setup/system-roles/$id/* — exists so the detail (index)
// and the edit route can both nest under a common parent. No shared chrome.
export const Route = createFileRoute('/_authenticated/setup/system-roles/$id')({
  component: () => <Outlet />,
});
